export interface IMetricsDataSourceItem {
  value: string;
  children: { value: string; props?: { sum?: boolean; avg?: boolean; max?: boolean } }[];
}

export interface IShowSumAvgMetrics {
  sum: string[];
  avg: string[];
  max: string[];
}

const EMPTY_SHOW_SUM_AVG_METRICS: IShowSumAvgMetrics = { sum: [], avg: [], max: [] };

/**
 * 根据公共 datasource 配置生成汇总行白名单，并让所有 Source Steam 指标
 * 复用 steamcharts 下同名基础指标的汇总规则。
 */
export const buildShowSumAvgMetrics = (metricsDatasource?: IMetricsDataSourceItem[]): IShowSumAvgMetrics => {
  if (!Array.isArray(metricsDatasource) || metricsDatasource.length === 0) {
    return EMPTY_SHOW_SUM_AVG_METRICS;
  }

  return metricsDatasource.reduce(
    (prev: IShowSumAvgMetrics, cur) => {
      cur?.children?.forEach((item) => {
        const metricValues = [item?.value];
        if (cur?.value === 'steamcharts') {
          metricValues.push(`source_steam__${item?.value}`);
        }

        if (item?.props?.sum || item?.props?.max) {
          prev.sum.push(...metricValues);
        }
        if (item?.props?.avg) {
          prev.avg.push(...metricValues);
        }
        if (item?.props?.max) {
          prev.max.push(...metricValues);
        }
      });

      return prev;
    },
    { sum: [], avg: [], max: [] },
  );
};
